<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>再エネ賦課金単価登録</h1>
<div>
    <form [formGroup]="reEnergyTankaForm">
        <div *ngIf="showResult">
            <app-sgkc034d-re-energy-tanka-result-list (onDbClickRowEvent)="onDbClickRow($event)" [mode]="mode"
                [slideadjustmentunitpriceLstInformationlist]="slideadjustmentunitpriceLstInformationlist"
                id="resultlist"></app-sgkc034d-re-energy-tanka-result-list>
        </div>
        <div *ngIf="isVisibleApprovalInfo">
            <app-sgkc034d-re-energy-tanka-approval-info [slideadjustmentunitpriceInfo]="slideadjustmentunitpriceInfo"
                [mode]="mode" id="approvalinfo"></app-sgkc034d-re-energy-tanka-approval-info>
        </div>
        <div *ngIf="isVisibleTankaInfo">
            <app-sgkc034d-re-energy-tanka-info [slideadjustmentunitpriceInfo]="slideadjustmentunitpriceInfo"
                [mode]="mode" (onClickRegistrationEvent)="onClickRegistration()" (onClickDeleteEvent)="onClickDelete()"
                (onClickApprovalEvent)="onClickApproval()" id="tankainfo"></app-sgkc034d-re-energy-tanka-info>
        </div>
    </form>
</div>